import React,{ useRef,useMemo } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import MOCK_DATA from '../jsx/components/table/FilteringTable/MOCK_DATA_2.json';
import { COLUMNS } from '../jsx/components/table/FilteringTable/ColumnsComExpenses copy';
 import { Link,useNavigate } from "react-router-dom";
 import axios from "axios";
 import swal from 'sweetalert'; 
import '../jsx/components/table/FilteringTable/filtering.css';
import { Col, Row ,Dropdown} from 'react-bootstrap';
import InviteCustomer1 from '../jsx/constant/Employeeexpences';
import InviteCustomer11 from '../components/amilatsalary';

import InviteCustomer from '../jsx/constant/EditCompanyExpenses';
import InviteCustomer2 from '../jsx/constant/LoansReport';
 import Swal from 'sweetalert2'; 
import { CSVLink } from 'react-csv';
import  { useEffect,useState     } from 'react';


export const CompanyExpenses = () => {
	const columns = useMemo( () => COLUMNS, [] )
	//const data = useMemo( () => MOCK_DATA, [] )
  const [data, setData] = useState([])
  const [data2, setData2] = useState([])

  const [ID, setID] = useState(0)
  const [inviteModal , setInviteModal] = useState(false);
	const tableInstance = useTable({
		columns,
		data,	
		initialState : {pageIndex : 0}
	}, useFilters, useGlobalFilter, usePagination)
	
	const { 
		getTableProps, 
		getTableBodyProps, 
		headerGroups, 
		prepareRow,
		state,
		page,
		gotoPage,
		pageCount,
		pageOptions,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		setGlobalFilter,
	} = tableInstance
    const {globalFilter, pageIndex} = state	
    const navigate = useNavigate();

    const userdata = useRef();
    const invite1 = useRef();
    const invite = useRef();
    const invite2 = useRef();
    const invite11 = useRef();

    useEffect(() => {
      fetchProducts();
  }, [])

  const fetchProducts = async () => {
      await axios.get('https://suhba.education.com.ly/back/api/empexpences').then(({ data }) => {setData(data)}) 
  }
    const deleteUser = async (e,id)=> {
        e.preventDefault();
        swal({
          title: "هل متأكد من الحدف",
          text: " في حال حدف الملف لايمكنك استعادة هدا الملف",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
    
            axios.delete(`https://suhba.education.com.ly/back/api/expenses/${id}`)
            
              .then(res => {
                fetchProducts();
                swal({
                  title: "تم",
                  text: "تم الحدف بنجاح",
                  icon: "success",
                  timer: 2000,
                  button: false
                })
                navigate('#')
            
               
            });
        
          } else {
            swal("تم الغاء عملية الحدف");
          }
        
        });
    
    };
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect x="0" y="0" width="24" height="24"></rect>
            <circle fill="#000000" cx="5" cy="12" r="2"></circle>
            <circle fill="#000000" cx="12" cy="12" r="2"></circle>
            <circle fill="#000000" cx="19" cy="12" r="2"></circle>
          </g>
        </svg>
    )

    const EditData = async (e,id)=> {
      console.log(id);
      data.map((item) => {
        if (id == item.ExpenseID) {
          setData2(item)}})
        
        
      setID(id); 
     invite2.current.showInviteModal()
    }
    const show =(value)=>
{
setInviteModal(value)

}
const [totalSum, setTotalSum] = useState(0);
useEffect(() => {
  // Calculate the total sum of the amounts whenever `data` changes
  let sum = 0;
  page.forEach(item => {
    const amountStr = item.values?.Amount || item.original?.Amount;
    const amount = parseFloat(amountStr);
    if (!isNaN(amount)) {
      sum += amount;
    }
  });

  setTotalSum(sum);
}, [page]); // This useEffect runs whenever `data` changes
 const repayLoan = async (e,expenseId) => {
  try {
    const response = await axios.put(
      `https://suhba.education.com.ly/back/api/expensesrepay/${expenseId}`,
      {}
    );

    Swal.fire({
      icon: 'success',
      title: 'تمت العملية بنجاح',
      text: response.data.message,
    });

    // You can also refresh the list here if needed
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text: error.response?.data?.message || 'حدث خطأ أثناء التسديد',
    });
  }}
console.log("page",totalSum)
const employeeExpenseHeaders = [
  {
    label: "رقم المصروف",
    key: "ExpenseID"
  },
  {
    label: "التاريخ",
    key: "ExpenseDate"
  },
  {
    label: "نوع المصروف",
    key: "TypeName"
  },
  {
    label: "اسم الموظف",
    key: "FirstName"
  },
  {
    label: "القيمة",
    key: "Amount"
  }
];
const groupedHeaders = [
    { label: "الشهر", key: "Month" },
    { label: "نوع المصروف", key: "TypeName" },
    { label: "اسم الموظف", key: "FirstName" },
    { label: "التاريخ", key: "ExpenseDate" },
    { label: "القيمة", key: "Amount" },
    { label: "ملاحظة", key: "Note" }
];
const groupedExpenses = useMemo(() => {

    let result = [];

    const grouped = data.reduce((acc, item) => {

        const month = item.ExpenseDate.substring(0, 7);

        if (!acc[month]) {
            acc[month] = {};
        }

        if (!acc[month][item.TypeName]) {
            acc[month][item.TypeName] = [];
        }

        acc[month][item.TypeName].push(item);

        return acc;

    }, {});


    Object.keys(grouped).forEach(month => {

        let monthTotal = 0;

        result.push({
            Month: month,
            TypeName: "",
            FirstName: "",
            ExpenseDate: "",
            Amount: "",
            Note: "بداية الشهر"
        });


        Object.keys(grouped[month]).forEach(type => {

            let typeTotal = 0;


            grouped[month][type].forEach(item => {

                typeTotal += Number(item.Amount);
                monthTotal += Number(item.Amount);

                result.push({
                    Month: month,
                    TypeName: type,
                    FirstName: item.FirstName || "",
                    ExpenseDate: item.ExpenseDate,
                    Amount: item.Amount,
                    Note: ""
                });

            });


            result.push({
                Month: "",
                TypeName: "",
                FirstName: "",
                ExpenseDate: "",
                Amount: typeTotal,
                Note: `إجمالي ${type}`
            });

        });


        result.push({
            Month: "",
            TypeName: "",
            FirstName: "",
            ExpenseDate: "",
            Amount: monthTotal,
            Note: `إجمالي شهر ${month}`
        });


    });


    return result;

}, [data]);
const employeeGroupedHeaders = [
    {
        label: "الشهر",
        key: "Month"
    },
    {
        label: "اسم الموظف",
        key: "FirstName"
    },
    {
        label: "نوع المصروف",
        key: "TypeName"
    },
    {
        label: "التاريخ",
        key: "ExpenseDate"
    },
    {
        label: "القيمة",
        key: "Amount"
    },
    {
        label: "الحالة",
        key: "Status"
    },
    {
        label: "ملاحظة",
        key: "Note"
    }
];
const employeeGroupedExpenses = useMemo(() => {

    let result = [];

    const grouped = data.reduce((acc, item) => {

        const month = item.ExpenseDate.substring(0, 7);
        const employee = item.FirstName || "بدون موظف";

        if (!acc[month]) {
            acc[month] = {};
        }

        if (!acc[month][employee]) {
            acc[month][employee] = [];
        }

        acc[month][employee].push(item);

        return acc;

    }, {});


    Object.keys(grouped).forEach(month => {

        let monthTotal = 0;


        result.push({
            Month: month,
            FirstName: "",
            TypeName: "",
            ExpenseDate: "",
            Amount: "",
            Status: "",
            IsUnpaidLoan: false,
            Note: "بداية الشهر"
        });


        Object.keys(grouped[month]).forEach(employee => {

            let employeeTotal = 0;


            grouped[month][employee].forEach(item => {

                employeeTotal += Number(item.Amount);
                monthTotal += Number(item.Amount);


                result.push({
                    Month: month,
                    FirstName: employee,
                    TypeName: item.TypeName,
                    ExpenseDate: item.ExpenseDate,
                    Amount: item.Amount,

                    Status: item.TypeName === "سلفة موظف"
                        ? item.Status
                        : "",

                    // true means this row needs bold in Excel
                    IsUnpaidLoan:
                        item.TypeName === "سلفة موظف" &&
                        item.Status !== "مسددة",

                    Note: ""
                });

            });


            result.push({
                Month: "",
                FirstName: employee,
                TypeName: "",
                ExpenseDate: "",
                Amount: employeeTotal,
                Status: "",
                IsUnpaidLoan: false,
                Note: `إجمالي ${employee}`
            });


            result.push({
                Month: "",
                FirstName: "",
                TypeName: "",
                ExpenseDate: "",
                Amount: "",
                Status: "",
                IsUnpaidLoan: false,
                Note: ""
            });

        });


        result.push({
            Month: "",
            FirstName: "",
            TypeName: "",
            ExpenseDate: "",
            Amount: monthTotal,
            Status: "",
            IsUnpaidLoan: false,
            Note: `إجمالي شهر ${month}`
        });


        result.push({
            Month: "",
            FirstName: "",
            TypeName: "",
            ExpenseDate: "",
            Amount: "",
            Status: "",
            IsUnpaidLoan: false,
            Note: ""
        });

    });


    return result;

}, [data]);
// const employeeGroupedExpenses = useMemo(() => {

//     let result = [];

//     const grouped = data.reduce((acc, item) => {

//         const month = item.ExpenseDate.substring(0, 7);
//         const employee = item.FirstName || "بدون موظف";

//         if (!acc[month]) {
//             acc[month] = {};
//         }

//         if (!acc[month][employee]) {
//             acc[month][employee] = [];
//         }

//         acc[month][employee].push(item);

//         return acc;

//     }, {});


//     Object.keys(grouped).forEach(month => {

//         let monthTotal = 0;


//         result.push({
//             Month: month,
//             FirstName: "",
//             TypeName: "",
//             ExpenseDate: "",
//             Amount: "",
//             Note: "بداية الشهر"
//         });


//         Object.keys(grouped[month]).forEach(employee => {

//             let employeeTotal = 0;


//             grouped[month][employee].forEach(item => {

//                 employeeTotal += Number(item.Amount);
//                 monthTotal += Number(item.Amount);


//                result.push({
//     Month: month,
//     FirstName: employee,
//     TypeName: item.TypeName,
//     ExpenseDate: item.ExpenseDate,
//     Amount: item.Amount,
//     Status: item.TypeName === "سلفة موظف"
//         ? item.Status
//         : "",
//     Note: ""
// });

//             });


//            result.push({
//     Month: "",
//     FirstName: employee,
//     TypeName: "",
//     ExpenseDate: "",
//     Amount: employeeTotal,
//     Status: "",
//     Note: `إجمالي ${employee}`
// });

// result.push({
//     Month: "",
//     FirstName: "",
//     TypeName: "",
//     ExpenseDate: "",
//     Amount: "",
//     Status: "",
//     Note: ""
// });
//         });


//         result.push({
//             Month: "",
//             FirstName: "",
//             TypeName: "",
//             ExpenseDate: "",
//             Amount: monthTotal,
//             Note: `إجمالي شهر ${month}`
//         });
// result.push({
//     Month: "",
//     FirstName: "",
//     TypeName: "",
//     ExpenseDate: "",
//     Amount: "",
//     Status: "",
//     Note: ""
// });

//     });


//     return result;

// }, [data]);
console.log("Original data", data);
console.log("Grouped data", groupedExpenses);
    return(
<>
<div className='container-fluid'>
				 
                 <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting p-0">   

                 <div className="tbl-caption p-0"  style={{float:"left"}}>
                  <div>
                     < Link to={"#"} className="btn btn-primary btn-sm m-1" data-bs-toggle="offcanvas"
                                 onClick={() => invite11.current.showInviteModal()}
                               > + إضافة مرتبات العاملات </Link>   
                                  
                        < Link to={"#"} className="btn btn-primary btn-sm m-1" data-bs-toggle="offcanvas"
                                 onClick={() => invite1.current.showInviteModal()}
                               > + إضافة مصروفات </Link>   
                                  
                              
                                 <Link to={"#"} className="btn btn-secondary btn-sm m-1" data-bs-toggle="offcanvas"
                                  onClick={() => invite.current.showInviteModal()}>
                                 <i class="fa-solid fa-hand-holding-dollar fa-lg mx-1"> </i>ديون الموظفين </Link>                             
<CSVLink
    data={groupedExpenses}
    headers={groupedHeaders}
    filename={"Employee_Expenses.csv"}
    className="btn btn-success btn-sm mt-1 mt-sm-0 ms-1"
    target="_blank"
>
    تصدير Excel
</CSVLink> 
<CSVLink
    data={employeeGroupedExpenses}
    headers={employeeGroupedHeaders}
    filename="Employee_Expenses_Report.csv"
    className="btn btn-info btn-sm mt-1 mt-sm-0 ms-1"
>
     تصدير Excel حسب الموظف
</CSVLink>

                            </div>
                            
                            
                        </div>  
                        <div className="col-md-4" style={{display :'flex'}}>
                              
                            <i style={{color: 'green'}} class="fa-solid fa-money-bill-transfer fa-xl m-2"></i>

          <label htmlFor="startMonth" style={{fontsize: '15px', fontWeight: 'bold',color: 'blue'}}>  اجمالي الصرف :</label>
       <div style={{color: 'green'}}> 
       <strong>{totalSum}</strong>  
        </div>  </div>
                        </div>     
                   
                       
                        		 
								<div className="table-responsive">
									<table {...getTableProps()} className="table dataTable display table-hover">
										<thead>
										{headerGroups.map(headerGroup => (
												<tr {...headerGroup.getHeaderGroupProps()}>
												      {headerGroup.headers.map((column) => (
                        // Check if the column accessor is 'age' and render accordingly
                        column.id !== 'ExpenseID' ? (
                          <th {...column.getHeaderProps()}>
                            {column.render('Header')}
                            {column.canFilter ? column.render('Filter') : null}
                          </th>
                        ) : null
                      ))}
												</tr>
										))}
										</thead> 
                                        <tbody {...getTableBodyProps()} className="" >
                                        
                                        {page.map((row) => {
                                            prepareRow(row)
                                            return(
                                                <tr {...row.getRowProps()}>

                                                    {row.cells.map((cell) => (
          // Check if the column accessor is 'age' and render accordingly
          cell.column.id !== 'ExpenseID' ? (
            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
          ) :null
        ))}


                                                     <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        className="light sharp i-false" 
                      >
                           {svg1}
                       </Dropdown.Toggle>
                      <Dropdown.Menu dir="rtl" className="dropdown-menu-right">
                         
  <Dropdown.Item>                               
                                                        
                         <Link to className=""
                               onClick={(e) =>repayLoan(e,row.original.ExpenseID)}
                               >تسديد السلفة
                            </Link>
                        </Dropdown.Item>
                       
                        <Dropdown.Item>                               
                                                        
                         <Link to className=""
                               onClick={(e) =>EditData(e,row.original.ExpenseID)}
                               >تعديل
                            </Link>
                        </Dropdown.Item>

                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
									</table>



									<div className="d-flex justify-content-between mx-2">
										<span>
											الصفحه{' '}
											<strong>
												{pageIndex + 1} من {pageOptions.length}
											</strong>{''}
										</span>
										<span className="table-index ">
											ادهب الى : {' '}
											<input type="number" 
												className="ml-2"
												defaultValue={pageIndex + 1} 
												onChange = {e => { 
													const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0 
													gotoPage(pageNumber)
												} } 
											/>
										</span>
									</div>
                                    <div className="text-center mb-3">  
                                        <div className="filter-pagination  mt-3">
                                            <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                                                {/* {'<'} */}
                                                <i className='fa-solid fa-angle-right' />
                                            </button>
                                            
                                            <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                السابق
                                            </button>
                                            <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                                                التالي
                                            </button>
                                            <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                                                {/* {'>'} */}
                                                <i className='fa-solid fa-angle-left' />
                                            </button>
                                        </div>
                                    </div>
								</div>
						 
						 
			</div>
            <InviteCustomer1
                ref={invite1}     
                parentFunction={fetchProducts}  
            />    
             <InviteCustomer11
                ref={invite11}     
                parentFunction={fetchProducts}  
            />          
<InviteCustomer2
                ref={invite}     
             /> 
             
             <InviteCustomer
                       ref={invite2}     
                data={data2}
                parentFunction={fetchProducts}  
                inviteModal={inviteModal}
                show={show}
            /> 
</>


    );
}
export default CompanyExpenses;